import React, { useState, useEffect, ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { useInsightContentData } from 'hooks/useInsightModalState'
// @ts-ignore
import { Menu, Select } from '@netbasequid/core'
import { DashboardWidgetData } from 'features/widget/types'
import { SentenceRetrievalResult } from 'schemas/SentenceRetrievalResultSchema'
import { useDisplayTheme } from 'hooks/useUiState'
import { Theme } from 'features/ui/types'
import messageUtil from 'utils/messageUtil'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import RunSearchEffect from './RunSearchEffect'
import { InsightContentSettingType } from '../types'
import SentenceSoundbite from './SentenceSoundbite'
import InsightContentType from '../enum/InsightContentType'
import SoundbitesSortType from '../enum/SoundbitesSortType'
import LoadingSoundbiteGroup from './LoadingSoundbiteGroup'
import { StyledSortingContainer, StyledWarningMessage } from './index.css'

const SELECT_WIDTH = '210px'

const Soundbite = ({
  detailSetting,
  enableHeaderTweet
}: {
  detailSetting: InsightContentSettingType
  enableHeaderTweet?: boolean
}) => {
  const insightContent = useInsightContentData(InsightContentType.SOUND_BITE)
  const [value, setValue] = useState(SoundbitesSortType.RICHNESS)
  const theme = useDisplayTheme() as Theme
  const [includeHeaderTweet, setIncludeHeaderTweet] = useState(false)
  const [showRetweetInfo, setShowRetweetInfo] = useState(false)
  const { t } = useTranslation()
  const noSoundBites =
    insightContent?.status === 'succeeded' &&
    insightContent.data[0].results[0].data.sentences.length === 0

  useEffect(() => {
    if (enableHeaderTweet && insightContent?.status === 'succeeded' && insightContent.isRetry) {
      setShowRetweetInfo(true)
      setIncludeHeaderTweet(true)
    }
  }, [enableHeaderTweet, insightContent, detailSetting, value, includeHeaderTweet, showRetweetInfo])

  return (
    <UnexpectedErrorBoundary>
      <RunSearchEffect
        detailSetting={detailSetting}
        sortBy={value}
        includeHeaderTweet={includeHeaderTweet}>
        {!noSoundBites && (
          <StyledSortingContainer>
            {t('sortBy')}
            <Select
              disabled={insightContent?.status === 'loading'}
              name="insight-modal-select"
              width={SELECT_WIDTH}
              mode={theme}
              value={value}
              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                setValue(event.target.value)
              }}
              menuProps={{
                disablePortal: true
              }}>
              <Menu.MenuItem value={SoundbitesSortType.RICHNESS}>
                {messageUtil.soundbiteSortOptions(SoundbitesSortType.RICHNESS)}
              </Menu.MenuItem>
              <Menu.MenuItem value={SoundbitesSortType.TIME}>
                {messageUtil.soundbiteSortOptions(SoundbitesSortType.TIME)}
              </Menu.MenuItem>
              <Menu.MenuItem value={SoundbitesSortType.AUTHOR_FOLLOWER}>
                {messageUtil.soundbiteSortOptions(SoundbitesSortType.FOLLOWERS_VISITORS)}
              </Menu.MenuItem>
            </Select>
          </StyledSortingContainer>
        )}

        {insightContent?.status === 'loading' ? (
          <LoadingSoundbiteGroup />
        ) : (
          <>
            {noSoundBites && (
              <StyledWarningMessage mode={theme} noBorder>
                {t('noSoundBitesForSelectedItems')}
              </StyledWarningMessage>
            )}
            {showRetweetInfo && !noSoundBites && (
              <StyledWarningMessage mode={theme}>
                {t('originalTweetsInRetweets')}
              </StyledWarningMessage>
            )}
            {insightContent?.data &&
              insightContent?.data.map(
                (data: DashboardWidgetData<SentenceRetrievalResult>, index: number) => (
                  <SentenceSoundbite
                    data={data.results![0]!.data}
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    serialNumber={index}
                  />
                )
              )}
          </>
        )}
      </RunSearchEffect>
    </UnexpectedErrorBoundary>
  )
}
export default Soundbite
